import mailIcon from './mail-icon.svg';
import arrowIconW from './arrow-icon-w.svg';
import arrowIconB from './arrow-icon-b.svg';
import pFlag from './p-flag.svg';
import eFlag from './e-flag.svg';
import uaFlag from './ua-flag.svg';
import pidarskiytricolor from './pidarskiy-tricolor.svg';
import logo from './logo-icon.svg';


import mainVideo from './Video/main-video.mp4';

const Icon = {
    mailIcon,
    arrowIconW,
    arrowIconB,
    pFlag,
    eFlag,
    uaFlag,
    logo,
    pidarskiytricolor,
    mainVideo

};

export default Icon;